// extracted by mini-css-extract-plugin
export default {"wrapldsSpinner":"spinner_wrapldsSpinner__tlnDY","ldsSpinner":"spinner_ldsSpinner__cdAmF"};